import styled from "styled-components";
import breakpoint from "../assets/breakpoints";

export const Container = styled.div`
  display: flex;
  background-color: #f8f9fd;
  padding-left: 78px;
  padding-top: 0px;
  height: 100vh;
  width: 100vw;
  @media only screen and ${breakpoint.device.sm} {
    padding-left: 0;
    padding-top: 56px;
  }
`;
export const Topbar = styled.div`
  position: fixed;
  display: none;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  background-color: #11101d;
  justify-content: center;
  align-items: center;
  z-index: 99;
  @media only screen and ${breakpoint.device.sm} {
    display: flex;
  }
`;
